import React from "react";
import { connect } from "react-redux";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
    fetchSkills,
    fetchExperiences,
    addSkill,
    updateRate,
    deleteSkill,
    addExperience,
    removeExperience
} from "@actions/technician";
import Experiences from "@components/shared/experiences";
import Specialties from "@components/shared/skills";

class Skills extends React.Component {
    async componentDidMount() {
        const { skills_loading, exp_loading } = this.props;
        if (!skills_loading) await this.props.fetchSkills(this.props.tech_id);
        if (!exp_loading) await this.props.fetchExperiences(this.props.tech_id);
    }

    handleAddSkill = (_, data) => this.props.addSkill(data);
    handleUpdateRate = (_, data) => this.props.updateRate(data);
    handleDeleteSkill = id => this.props.deleteSkill(id);

    handleAddExperience = data => this.props.addExperience(data);
    handleDeleteExperience = id => this.props.removeExperience(id);

    render() {
        const { messages, skills, skills_loading, exp_loading, exp } = this.props;

        return (
            <Container>
                <Specialties
                    skills={skills}
                    loading={skills_loading}
                    technician={this.props.tech_id}
                    onAddedSkill={this.handleAddSkill}
                    onUpdatedRate={this.handleUpdateRate}
                    onDeletedSkill={this.handleDeleteSkill}
                    onDetails={skill => {
                        return <Link to={`/t/skill/${skill.id}`}>{messages["seeDetails"]}</Link>;
                    }}
                />

                <Experiences
                    loading={exp_loading}
                    experiences={exp}
                    technician={this.props.tech_id}
                    onAddedExperience={this.handleAddExperience}
                    onDeletedExperience={this.handleDeleteExperience}
                />
            </Container>
        );
    }
}

const mapStateToProps = state => ({
    skills: state.tech.skill.list,
    skills_loading: state.tech.skill.loaded,
    exp: state.tech.exp.list,
    exp_loading: state.tech.exp.loaded,
    tech_id: state.auth.user.id
});

export default connect(mapStateToProps, {
    fetchSkills,
    fetchExperiences,
    addSkill,
    updateRate,
    deleteSkill,
    addExperience,
    removeExperience
})(Skills);
